import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, Package, Lifebuoy, UserCircle } from '@phosphor-icons/react';
import { useUnread } from '../lib/unread';

const TABS = [
  { to: '/', label: 'Home', icon: House, test: 'bottom-nav-home' },
  { to: '/orders', label: 'My Orders', icon: Package, test: 'bottom-nav-orders', unreadTab: true },
  { to: '/support', label: 'Support', icon: Lifebuoy, test: 'bottom-nav-support' },
  { to: '/profile', label: 'Profile', icon: UserCircle, test: 'bottom-nav-profile' },
];

const BottomNav = () => {
  const { pathname } = useLocation();
  const { total } = useUnread();
  return (
    <div
      className="absolute bottom-2 left-2 right-2 grid grid-cols-4 rounded-2xl z-30"
      style={{
        background: 'color-mix(in srgb, #ffffff 68%, transparent)',
        backdropFilter: 'blur(14px) saturate(180%)',
        WebkitBackdropFilter: 'blur(14px) saturate(180%)',
        border: '1px solid rgba(255, 255, 255, 0.55)',
        boxShadow:
          '0 12px 28px -10px rgba(0, 0, 0, 0.25), 0 2px 4px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255, 255, 255, 0.65)',
      }}
      data-testid="bottom-nav"
    >
      {TABS.map((t) => {
        const Icon = t.icon;
        const active = t.to === '/' ? pathname === '/' : pathname.startsWith(t.to);
        const showBadge = t.unreadTab && total > 0;
        return (
          <Link
            key={t.to}
            to={t.to}
            data-testid={t.test}
            className="group flex flex-col items-center justify-center gap-0.5 py-2 relative rounded-2xl transition-transform duration-150 ease-out active:scale-90"
          >
            <div
              className="relative flex items-center justify-center transition-all duration-200 ease-out group-active:scale-90"
              style={{
                background: active ? 'color-mix(in srgb, var(--pk-primary) 14%, transparent)' : 'transparent',
                width: 34,
                height: 34,
                borderRadius: 12,
              }}
            >
              <Icon size={18} weight={active ? 'fill' : 'regular'} color={active ? 'var(--pk-primary)' : '#0a0a0a'} />
              {showBadge && (
                <span
                  className="absolute -top-1 -right-2 min-w-[14px] h-[14px] px-1 border-2 border-black text-white text-[8px] font-bold flex items-center justify-center font-mono leading-none rounded-full"
                  style={{ background: 'var(--pk-primary)' }}
                  data-testid="bottom-nav-orders-badge"
                >
                  {total > 9 ? '9+' : total}
                </span>
              )}
            </div>
            <span
              className="text-[8px] tracking-[0.14em] uppercase font-bold transition-colors duration-200"
              style={{ color: active ? 'var(--pk-primary)' : '#0a0a0a' }}
            >
              {t.label}
            </span>
            {active && (
              <span
                className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 w-6 h-[3px] rounded-full transition-all duration-200"
                style={{ background: 'var(--pk-primary)' }}
              />
            )}
          </Link>
        );
      })}
    </div>
  );
};

export default BottomNav;
